import { Vendor } from 'src/app/shared/models/database-models';

export const validateVendorsEmail = (
  vendors: Vendor[],
  vendorNumbers: NonNullable<Vendor['VendorNumber']>[]
) => {
  return vendors
    .filter(
      (vendor) =>
        vendor.VendorNumber &&
        !vendor.isDeleted &&
        !vendor.Strikethrough &&
        vendorNumbers.includes(vendor.VendorNumber)
    )
    .every((vendor) => {
      return vendor.EmailAddress || vendor.OtherPersonEmail;
    });
};

export const validateVendorsEmailRO = (vendors: any) => {
  let hasEmail = true;
  vendors.forEach((vendor: any) => {
    if (!vendor.EmailAddress && !vendor.OtherPersonEmail) {
      hasEmail = false;
    }
  });
  return hasEmail;
};
